/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import { PRODUCTS } from '../../Context/productConfig';  


import "../../../../../assets/vendor/nucleo/css/nucleo.css";
import "../../../../../assets/vendor/font-awesome/css/font-awesome.min.css";
import "../../../../../assets/scss/argon-design-system-react.scss?v1.1.0";

import "assets/fonts/Inter-VariableFont.ttf";

// section components
import './Index.css'
import StoreNavbar from "../../../../../components/Navbars/StoreNavbar/Index";
import Description from "./Description";
import PlanSelector from "../../../../../components/PlanSelector/PlanSelection";
import Footer from "../../../../../components/Footers/StoreFooter/Footer";



class VoiceConditioning extends React.Component {
    
  state = {};

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {

    return (
      <div className="main-landing-page">

        <StoreNavbar />

        <main ref="main">

            <PlanSelector product={PRODUCTS.VOICE_CONDITIONING}></PlanSelector>

            <Description></Description>


            <Footer></Footer>
          
        </main>

      </div>
    );
  }
}

export default VoiceConditioning;
